import DramoxImage from 'components/DramoxImage';
import Analytics from 'helpers/Analytics';
import useTranslation from 'next-translate/useTranslation';
import { Namespace } from '../../enums/namespaces';
import { Permalink, truncateTitle } from '../../helpers';
import { PlayBase, PlayState, TheatreBase } from '../../typings/api';
import AppLink from '../AppLink/AppLink';

type Plays = PlayBase & TheatreBase;

interface Props {
  headline: string;
  plays: Plays[];
  theatre?: string;
  index?: number;
}

const CategorySectionFull = ({ headline, plays, theatre, index }: Props): JSX.Element => {
  const { lang, t } = useTranslation(Namespace.Common);
  return (
    <div className={`category-section category-section-full ${!index || index === 0 ? 'first' : ''}`}>
      <div className="play-list-wrapper">
        <h2>{headline}</h2>
        <ul className="play-list">
          {plays?.map((play, i) => (
            // onClick={() => playsGEvent(item.permalink)}
            <li key={i}>
              <AppLink href={Permalink.play(play, lang)}>
                <a tabIndex={-1}>
                  {play.state === PlayState.PROMOTED ? <p className="coming-soon">{t('coming_soon')}</p> : null}
                  <DramoxImage
                    placeholderClass="image-wrapper-for-playlist"
                    src={play.poster_url}
                    alt={play.title}
                    width={256}
                    height={144}
                    quality={90}
                  />
                  <div>
                    <h3>{truncateTitle(play.title)}</h3>
                    <p>{play?.theatre?.name ?? theatre}</p>
                  </div>
                </a>
              </AppLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CategorySectionFull;
